export default () => ({
  schedules: [],
  entity: 'schedule',
  entities: 'schedules',
  errors: {},
  isShowActive: false,
  isMobiled: false,
  loading: false,
  onCancel: true,
  fullPage: true
})



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/nexts/resources/data.js